module.exports = __webpack_public_path__ + "img/zd1.8815d721.png";